// Generated from backend/workers/core-backend/port-manifest.json. Do not edit:
// change a status there, then run `node scripts/routed-functions.ts` from
// backend/workers/core-backend (Node 24).

export const ROUTED_FUNCTIONS_OPT_IN: readonly string[] = [];

export const ROUTED_FUNCTIONS_EVERYONE: readonly string[] = [
  'ads-advertiser-review-api',
  'ads-api',
  'ads-media-url',
  'analyze-voice',
  'approve-rejected-email',
  'archive-intent-reconciler',
  'auto-tag-document',
  'backfill-attachment-metadata',
  'backfill-email-bodies',
  'billing-admin',
  'billing-month-end',
  'billing-payment-sweep',
  'brand-font-delete',
  'brand-font-gc',
  'brand-font-upload',
  'brand-kit-actions',
  'broadcast-actions',
  'broadcast-ideas',
  'broadcast-image-upload',
  'capture-external-email',
  'check-url-safety',
  'cleanup-email-bodies',
  'cleanup-knowledge-storage',
  'clip-studio-actions',
  'clip-studio-sweeper',
  'compute-response-status',
  'constituent-sync-drainer',
  'contact-support',
  'correspondence-actions',
  'correspondence-api',
  'correspondence-interactions',
  'correspondence-saved-view-counts',
  'create-comment',
  'creative-image-mask',
  'delete-comment',
  'document-comments',
  'draft-actions',
  'draft-commitments',
  'draft-learning-admin',
  'draft-learning-voice',
  'email-analytics',
  'email-enrichment-drainer',
  'email-list',
  'email-metadata-counter',
  'email-signature-image-upload',
  'enhance-highlighted-selection',
  'enrich-companies',
  'evaluate-auto-draft',
  'evaluate-email-for-kb',
  'extract-email-contacts',
  'facebook-historical-backfill',
  'facebook-scraper',
  'facebook-sync-drain',
  'feature-flags',
  'gdrive-list-folders',
  'gdrive-sync',
  'generate-creative-copy',
  'generate-draft',
  'generate-email-metadata',
  'generate-native-graphic',
  'generate-voice-sample',
  'geo-tag-constituents',
  'get-attachment-url',
  'get-comment-attachment-url',
  'get-comments',
  'get-voice-profile',
  'gmail-api',
  'gmail-watch',
  'imap-connect',
  'import-constituents',
  'import-jobs',
  'import-uploads-gc',
  'import-worker',
  'ingest-external-email',
  'ingest-forwarded-email',
  'integrations-api',
  'knowledge-web-discover',
  'knowledge-web-monitor',
  'manage-external-share',
  'manage-sessions',
  'match-constituent-address',
  'match-constituent-addresses',
  'members-manage-organization-member',
  'members-manage-staff-member',
  'members-remove-organization-member',
  'members-remove-staff-member',
  'members-reset-mfa',
  'members-suspend-staff-member',
  'mention-share-decision',
  'messaging-connect',
  'messaging-media-gc',
  'messaging-react',
  'messaging-send',
  'meta-data-deletion',
  'metrics-exporter',
  'mfa-clear-unverified-factors',
  'minrep-body-image-gc',
  'minrep-body-image-upload',
  'mobile-push-diagnostics',
  'newsroom-actions',
  'newsroom-maintenance',
  'office-messenger',
  'org-signature-upload',
  'outlook-api',
  'outlook-subscription',
  'potential-duplicate-scan',
  'process-ad-content-analysis',
  'process-ad-exposure-scores',
  'process-broadcast-ab-decisions',
  'process-broadcast-events',
  'process-broadcast-sends',
  'process-clip-jobs',
  'process-draft-recipients',
  'process-messaging-deliveries',
  'process-metadata-generation-jobs',
  'process-organization-cleanup',
  'process-scheduled-emails',
  'process-webhook-deliveries',
  'proxy-image',
  'public-ad',
  'public-correspondence',
  'public-preferences',
  'public-unsubscribe',
  'pulse-ai-admin-review',
  'pulse-ai-asset-content',
  'pulse-ai-asset-delete',
  'pulse-ai-asset-upload',
  'pulse-ai-capabilities',
  'pulse-ai-chat',
  'pulse-ai-janitor',
  'pulse-ai-transcribe',
  'pulse-ai-website-dispatch',
  'push-preview',
  'redirected-inbound-drainer',
  'refresh-gmail-settings',
  'register-push-token',
  'render-broadcast',
  'render-email',
  'renew-webhooks',
  'repair-email-body-text',
  'reporting-widget-data',
  'representation-actions',
  'request-document-render',
  'request-minrep-render',
  'reset-password',
  'resolve-comment',
  'rules-engine-worker',
  'save-email-to-knowledge',
  'semantic-knowledge-search',
  'send-draft',
  'send-magic-link-otp',
  'send-push-notification',
  'sending-domains',
  'set-external-share-policy',
  'set-org-profile',
  'set-voice-profile',
  'snooze-lifecycle',
  'social-profile-actions',
  'storage-snapshot',
  'suggest-tasks-from-email',
  'suppressions-import',
  'sync-emails',
  'sync-emails-backfill-drainer',
  'sync-emails-catchup',
  'sync-emails-drainer',
  'sync-messaging',
  'template-reconstruction-actions',
  'toggle-comment-reaction',
  'unregister-push-token',
  'update-comment',
  'validate-library-dataset',
  'verify-sending-domains',
  'webhook-gdrive',
  'webhook-gmail',
  'webhook-messaging',
  'webhook-outlook',
  'webhook-sendgrid',
  'website-identity-render-dispatch',
  'website-publication-dispatch',
  'websites-api',
  'websites-domains',
  'websites-intake',
  'websites-newsroom',
  'websites-page-view-rollup',
  'websites-preview',
];
